import React from 'react';
import HistoryItem from '../HistoryItem';
import { convertDate } from '../../routes/lineItems/components/utils';
 
const Sidesheet = ({ sidesheetClass, closeSidesheet, history }) => {

  const createdItem = history.filter(item => item.action === 'CREATED')
  const historyList = history.map((item, i) => <HistoryItem key={i} item={item} />)

  return (
    <div className={`axiom-sidesheet-overlay ${sidesheetClass}`} >
      <div className="axiom-sidesheet-container">
        <div className="axiom-sidesheet-header">
          <button className="axiom-sidesheet-close-button axiom-icon-icon icon-x" onClick={closeSidesheet} />
          <span className="axiom-sidesheet-title"> History </span>
        </div>
        <div className="axiom-sidesheet-body">
          {createdItem.length > 0 && <div className="created"><span>Created:</span> {convertDate(createdItem[0].createdAt)}</div>}
          <ul className="history">
            {historyList}
          </ul>
          {history.length === 0 && 'No data.'}
        </div>
      </div>
    </div>
  )
}

export default Sidesheet